import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type { Error } from '@eggplant/types'

interface Props {
  modelId: string
  assetId: string
  onError?: (error: Error) => void
  onSuccess?: () => void
  children?: () => void
}

const DeleteAiModelAssetRequest = ({
  modelId,
  assetId,
  onError,
  onSuccess,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/models/${modelId}/assets/${assetId}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='delete'
      onError={onError}
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default DeleteAiModelAssetRequest
